import UUID from "@/assets/js/uuid";

const state = {
    dataSource: [
        {
            key: '1',
            name: '肖申克的救赎',
            subtitle: 'Top 250',
            remark: 'reserve',
            url: '',
            isShow: false
        },
        {
            key: '2',
            name: '霸王别姬',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '3',
            name: '阿甘正传',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '4',
            name: '这个杀手不太冷',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '5',
            name: '泰坦尼克号',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '6',
            name: '美丽人生',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '7',
            name: '千与千寻',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '8',
            name: '辛德勒的名单',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '9',
            name: '盗梦空间',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '10',
            name: '星际穿越',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '11',
            name: '海上钢琴师',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '12',
            name: '楚门的世界',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '13',
            name: '机器人总动员',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '14',
            name: '放牛班的春天',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '15',
            name: '大话西游',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '16',
            name: '疯狂动物城',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '17',
            name: '无间道',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '18',
            name: '教父',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '19',
            name: '当幸福来敲门',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '20',
            name: '龙猫',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '21',
            name: '怦然心动',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '22',
            name: '触不可及',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '23',
            name: '乱世佳人',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '24',
            name: '何以为家',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '25',
            name: '飞屋环游记',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '26',
            name: '鬼子来了',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '27',
            name: '天空之城',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '28',
            name: '猫鼠游戏',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '29',
            name: '搏击俱乐部',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '30',
            name: '大闹天宫',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '31',
            name: '狮子王',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '32',
            name: '死亡诗社',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '33',
            name: '黑客帝国',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '34',
            name: '指环王',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '35',
            name: '饮食男女',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '36',
            name: '窃听风暴',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '37',
            name: '美丽心灵',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '38',
            name: '让子弹飞',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '39',
            name: '两杆大烟枪',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '40',
            name: '本杰明·巴顿奇事',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '41',
            name: '飞越疯人院',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '42',
            name: '西西里的美丽传说',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '43',
            name: '拯救大兵瑞恩',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '44',
            name: '小鞋子',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '45',
            name: '情书',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '46',
            name: '海豚湾',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '47',
            name: '美国往事',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '48',
            name: '低俗小说',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '49',
            name: '心灵捕手',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '50',
            name: '摩登时代',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '51',
            name: '阿凡达',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '52',
            name: '勇敢的心',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '53',
            name: '狩猎',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '54',
            name: '红辣椒',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '55',
            name: '阳光灿烂的日子',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '56',
            name: '重庆森林',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        },
        {
            key: '57',
            name: '小森林',
            subtitle: 'Top 250',
            remark: '',
            url: '',
            isShow: false
        }
    ],
}

const mutations = {

    addItemAuto(state) {
        const uuid = UUID.uuid(4, 26)
        const newData = {
            key: uuid,
            name: 'title_' + uuid,
            subtitle: 'subtitle',
            remark: '',
            url: '',
            isShow: false
        }
        state.dataSource.unshift(newData)
    },

    addItem(state, item) {
        state.dataSource.unshift(item)
    },

    delItemByIndex(state, index) {
        state.dataSource.splice(index, 1)
    },

    updateSource(state, dataSource) {
        state.dataSource = dataSource
    },

    updateByItem(state, item) {
        state.dataSource.forEach((_item) => {
            if (_item.key == item.key) {
                _item = item
            }
        })
    },

    updateItemByIndex(state, item, index) {
        state.dataSource[index] = item
    },

    updateRemarkByIndex(state, remark, index) {
        state.dataSource[index].remark = remark
    },

    delItemByKey(state, key) {
        const dataSource = [...state.dataSource];
        state.dataSource = dataSource.filter(item => item.key !== key)
    },

    randomItem(state) {
        var length = state.dataSource.length
        var arr1 = new Array();
        for (let i = 0; i < length; i++) {
            arr1[i] = i;
        }
        // 建立数组下标数组
        var arr2 = new Array()
        for (let i = 0; i < length; i++) {
            arr2[i] = arr1.splice(Math.floor(Math.random() * arr1.length), 1)
        }
        // 将数组下标随机打乱
        var arr3 = new Array()
        for (let i = 0; i < length; i++) {
            arr3[i] = state.dataSource[arr2[i]]
        }
        // 将数组按打乱后的下标输出
        state.dataSource = arr3;
    },

    clearAll(state) {
        state.dataSource = []
    }
}

const actions = {}

const getters = {
    getDataSource(state) {
        return state.dataSource
    }
}

const computed = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
    computed
}
